export default __webpack_public_path__ + "static/media/Group 45807.ca21ec55.svg";